import { Button } from "antd";
import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import AddFund from "./AddFund";
import FundRequest from "./FundRequest";
import AddFund2 from "./AddFund2";
import AddFund3 from "./AddFund3";

const FundRequestmain = () => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(0);
  const tab = [
    { id: 1, name: "Add Fund", component: <AddFund /> },
    { id: 2, name: "Add Fund 2", component: <AddFund2 /> },
    { id: 3, name: "Add Fund 3", component: <AddFund3 /> },
    { id: 4, name: "Send Fund Request", component: <FundRequest /> },
  ];
  useEffect(() => {
    dispatch(setselectedTab("10"));
  }, []);
  return (
    <>
      <div className="mt-8  bg-white rounded-lg grid grid-cols-1 md:grid-cols-4 place-items-start md:place-items-center gap-y-4">
        {tab.map((i, index) => {
          return (
            <div className="w-full text-center">
              <p
                onClick={() => {
                  setSelected(index);
                }}
                className={`cursor-pointer transition-all  ${
                  i.id - 1 === selected
                    ? "bg-primary tab-active text-white"
                    : "border border-[#EBEBEB]"
                }  py-2 `}
              >
                {i.name}
              </p>
            </div>
          );
        })}
      </div>
      <div className="mt-4">{tab[selected].component}</div>
    </>
  );
};

export default FundRequestmain;
